import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';
import moment from 'moment';
import {durationToStr} from 'shared';
import {filter} from 'lodash';

@Component({
  selector: 'app-fields-interventions-tractors-usage-report',
  templateUrl: './fields-interventions-tractors-usage-report.component.html',
  styleUrls: ['./fields-interventions-tractors-usage-report.component.scss']
})
export class FieldsInterventionsTractorUsageReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  toolbarDs: DataSource;

  @Input()
  dataSource: PivotGridDataSource;

  @Input()
  currentReportType: any;

  @Input()
  reportCurrentViewModes: any;

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  @Input()
  width: number;

  @Input()
  height: number;
  chartHeight: number;

  constructor() {
  }

  ngOnInit(): void {

    // Set fields
    this.dataSource.fields([{
      caption: 'BU',
      width: 120,
      dataField: 'business_unit_name',
      area: 'filter',
      allowFiltering: true,
    }, {
      caption: 'Domaine',
      width: 120,
      dataField: 'domain_name',
      area: 'filter',
      allowFiltering: true,
    }, {
      caption: 'Operation',
      dataField: 'trailer_operation_type',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Tracteur',
      dataField: 'tractor_name',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Année',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'year',
      area: 'column'
    }, {
      caption: 'Mois',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'month',
      area: 'column'
    }, {
      caption: 'Jour',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'day',
      area: 'column'
    }, {
      caption: 'Durée Travaillée',
      dataField: 'vehicle_working_hours',
      dataType: 'number',
      summaryType: 'sum',
      format: (value) => {
        return durationToStr(value as number * 3600);
      },
      area: 'data'
    }, {
      caption: 'Durée disponible net (jour)',
      dataField: 'vehicle_net_available_days',
      dataType: 'number',
      summaryType: 'custom',
      calculateCustomSummary: (options) => {
        if (options.summaryProcess !== 'finalize') {
          options.totalValue = options.value || 0;
        }
      },
      area: 'data'
    },  {
      caption: 'Taux d\'utilisation net (%)',
      dataField: 'vehicle_net_usage_rate',
      dataType: 'number',
      summaryType: 'avg',
      format: 'percent',
      area: 'data'
    }, {
      caption: 'Durée disponible brut (jour)',
      dataField: 'vehicle_available_days',
      dataType: 'number',
      summaryType: 'custom',
      calculateCustomSummary: (options) => {
        if (options.summaryProcess !== 'finalize') {
          options.totalValue = options.value || 0;
        }
      },
      area: 'data'
    },  {
      caption: 'Taux d\'utilisation brut (%)',
      dataField: 'vehicle_usage_rate',
      dataType: 'number',
      summaryType: 'avg',
      format: 'percent',
      area: 'data'
    }]);

    this.chartHeight = filter(this.dataSource.fields(), (f) => {
      return f.area === 'data' && f.visible !== false;
    }).length * 350;

    this.toolbarDs.store().push([{
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.pivotGrid.instance.getFieldChooserPopup().show();
          }
        }
      },
      key: 'filter',
    },
      {
        type: 'update',
        data: {
          options: {
            onClick: () => {
              this.dataSource.reload();
            }
          }
        },
        key: 'refresh',
      }]);
  }

  ngAfterViewInit(): void {
    this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'splitAxes',
      alternateDataFields: false,
      inverted: true,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      },
      customizeChart: (chartOptions) => {
        return chartOptions; // This line is optional
      },
    });

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.dataSource);
  }

  ngOnDestroy(): void {
  }

  customizeTooltip(args) {
    return {
      html: args.seriesName + ': ' + args.valueText
    };
  }
}
